<div class="container-fluid  " style="background: #F8F8F8 0% 0% no-repeat padding-box;">
    <div class="row  pt-2" style="display: flex; align-items: center;">
        <div class="col-md-5 w-100">
            <div class="row  headerpageevents">
                <div class="col-md-6">
                    <p class="m-0 text-uppercase " style="font-size: 20px; color: #262756;font-weight:bold">événements
                    </p>
                    <small class="text-uppercase " style="font-size:15px;color: #707070;">liste des Manœuvres </small>
                </div>
                <div class="col-md-6">
                    <mat-form-field appearance="fill" class="">
                        <mat-date-range-input [formGroup]="rangeForm" [min]="minDate" [max]="maxDate"
                            [rangePicker]="picker2">
                            <input formControlName="start" autocomplete="off" readonly matStartDate
                                placeholder="Date Début">
                            <input formControlName="end" autocomplete="off" readonly matEndDate placeholder="End date"
                                (dateChange)="SubaddNewDate(rangeForm)">
                            (dateChange)="addNewDate(rangeForm)"
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker2" placement="left"
                            ngbTooltip="Filtrer par date Début-Fin">
                        </mat-datepicker-toggle>
                        <mat-date-range-picker maxRange=29 #picker2></mat-date-range-picker>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <div class="row pt-3" style="padding-top: 30px !important;">
        <div class="col-lg-5 col-md-12">
            <div class="row" style="display: flex; align-items: center;">
                <div class="export-icons col-md-5 d-flex justify-content-around">
                    <div class="icn-sec" (click)="exportExcel(exportDirective, 'xlsx')">
                        <img src="assets/newImages/excel-svg.svg" />
                    </div>
                    <div class="icn-sec" (click)="exportTable()">
                        <img src="assets/newImages/pdf-svg.svg" />
                    </div>
                </div>
                <div class="col-md-7 p-0">
                    <div class="row w-100 d-flex justify-content-between styleevents">
                        <div class="col-lg-5  col-md-6 pr-md-0">

                        </div>
                        <div class="col-lg-5 col-md-6 pr-md-0">

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-7 col-md-12 d-flex align-content-center ">
            <div class="row d-flex justify-content-end
            align-content-center container">
                <button mat-button type="submit" class="btn-get justify-content-center"
                    (click)="showFiltrage(filtrage)">
                    Filtrage
                </button>
            </div>
        </div>
    </div>
    <div class="row w-100 ml-0  pt-2">
        <div class="col-12 mb-2">
        </div>

        <div class="col-xl-9 col-lg-12 col-md-12 px-md-0 px-lg-0 pr-0 d-none">
            <mat-accordion class="example-headers-align w-100">
                <mat-expansion-panel
                    style="box-shadow: 5.9px 6.8px 15.5px rgb(137 148 169 / 28%), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgb(255 255 255 / 15%);">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Filtrage
                        </mat-panel-title>
                        <mat-panel-description>
                            <input disabled readonly type="text" autocomplete="off"
                                placeholder="Rechercher dans les événements" style="    border: none;
                                        background-color: white;
                                            font-weight: bold;
                                    height: auto;
                                    outline: none;
                                    width: 92%;
                                    color: #3b5876;" [(ngModel)]="options1.stepsArray[value1-1].legend">
                            <mat-icon (click)="executeFunction()">
                                update</mat-icon>
                            <mat-icon>filter_list</mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <form class="mt-4" [formGroup]="registerForm">
                        <div class="row">
                            <div class="col-md-8 w-100 mb-2">
                                <div class="row mt-2">
                                    <div class="col-md-6">
                                        <mat-form-field class="mb-2">
                                            <mat-label>ID. Dallas</mat-label>
                                            <input #input formControlName="dallas" matInput>
                                        </mat-form-field>

                                        <mat-form-field>
                                            <mat-label>Prénom ou Nom du conducteur</mat-label>
                                            <input #input formControlName="driver_name" matInput>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field class="mb-2">
                                            <mat-label>Nom de véhicule</mat-label>
                                            <input #input formControlName="unit_id" matInput>
                                        </mat-form-field>
                                        <!-- <mat-form-field class="mb-2">
                                            <mat-label>Plaque Véhicule</mat-label>
                                            <input matInput #input formControlName="plate">
                                        </mat-form-field> -->
                                        <mat-form-field appearance="fill">
                                            <mat-label>Type de véhicule</mat-label>
                                            <mat-select #input [formControl]="registerForm?.controls.unit_type2"
                                                multiple>
                                                <mat-select-trigger
                                                    *ngFor="let item of registerForm?.controls?.unit_type2">
                                                    {{registerForm.controls.unit_type2.value ?
                                                    registerForm.controls.unit_type2.value[0] : ''}}
                                                    <span *ngIf="registerForm.controls?.unit_type2.value?.length > 1"
                                                        class="example-additional-selection">
                                                        (+{{registerForm.controls.unit_type2.value.length - 1}}
                                                        {{registerForm.controls.unit_type2.value?.length === 2 ?'autre'
                                                        :'autres'}})
                                                    </span>
                                                </mat-select-trigger>
                                                <mat-option *ngFor="let topping of toppingList" [value]="topping">
                                                    {{topping?.typeVehicule}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="row">
                                    <div class="col-md-12 mb-2">
                                        <mat-form-field class="mb-2">
                                            <mat-label>Min Score de sécurité</mat-label> <input #input
                                                formControlName="safety_score_min" type="number" matInput
                                                [(ngModel)]="minValue">
                                            <span matSuffix>%&nbsp;</span>
                                        </mat-form-field>
                                        <mat-form-field class="mb-3">
                                            <mat-label>Max Score de sécurité</mat-label> <input #input
                                                formControlName="safety_score_max" type="number" matInput
                                                [(ngModel)]="maxValue">
                                            <span matSuffix>%&nbsp;</span>
                                        </mat-form-field>
                                        <ngx-slider [(value)]="minValue" [(highValue)]="maxValue" [options]="options">
                                        </ngx-slider>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 mb-5">
                                <ngx-slider formControlName="maneuver_type2" [(value)]="value1" [options]="options1">
                                </ngx-slider>
                            </div>
                            <div class="col-xl-11 col-lg-10 col-md-10  mt-3">
                            </div>
                            <div class="col-xl-1 col-lg-2 col-md-2 d-flex">
                                <button (click)="resetValue()" class="mr-2" mat-mini-fab color="primary"
                                    aria-label="Example icon button with a filter list icon">
                                    <mat-icon style="    color: #ffffff; "> format_color_reset</mat-icon>
                                </button>
                                <button (click)="submitForm()" mat-mini-fab color="primary"
                                    aria-label="Example icon button with a filter list icon">
                                    <mat-icon style="    color: #ffffff;">search</mat-icon>
                                </button>
                            </div>
                        </div>
                    </form>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
        <div class="row rowposition w-100 pt-1 m-0">
            <div class="w-100  col-md-12 col-xl-12 col-lg-12 px-0">
                <ngx-spinner *ngIf="showevents ==true" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
                    type="ball-clip-rotate-multiple" [fullScreen]="false">
                    <p style="color: white"> </p>
                </ngx-spinner>
                <hr style="border: 1px solid #e8e4e4;margin-top: 2%;margin-bottom: 3%;">
                <div class=" example-container w-100">
                    <table id="ExampleTable" class="table-hover" #exportDirective="matTableExporter" matTableExporter
                        mat-table [dataSource]="dataSource" matSort>
                        <!-- ID Column -->
                        <!-- <ng-container matColumnDef="trip_id">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                ID.Trajet
                            </th>
                            <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                                (click)="getItemDetails(row)">
                                {{ row?.trip_id }}
                            </td>
                        </ng-container> -->
                        <ng-container matColumnDef="unit">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                Véhicule
                            </th>
                            <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                                (click)="getItemDetails(row)">
                                {{ row?.unit }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="driver">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                Conducteur
                            </th>
                            <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                                (click)="getItemDetails(row)">

                                {{ row?.driver}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="maneuver_type">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                Type
                            </th>
                            <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                                (click)="getItemDetails(row)">
                                {{ row?.maneuver_type }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="risk_score">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                Score de sécurité
                            </th>
                            <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                                (click)="getItemDetails(row)">
                                <circle-progress
                                    *ngIf="row?.maneuver_type != 'Inactivité' && row?.maneuver_type != 'Accident' "
                                    [percent]="row?.risk_score" [showSubtitle]=false [radius]="25" [outerStrokeWidth]="2"
                                    [innerStrokeWidth]="1" [outerStrokeColor]="updateColor(row?.risk_score)"
                                    [innerStrokeColor]="updateColor(row?.risk_score)" [animation]="false"
                                    [animationDuration]="700" [titleFontSize]="18"></circle-progress>
                                <p *ngIf="row?.maneuver_type === 'Inactivité' || row?.maneuver_type === 'Accident' ">--
                                </p>

                            </td>
                        </ng-container>
                        <ng-container matColumnDef="maneuver_start">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                Date début
                            </th>
                            <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                                (click)="getItemDetails(row)">
                                {{ row?.maneuver_start }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="maneuver_end">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                Date fin
                            </th>
                            <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                                (click)="getItemDetails(row)">
                                {{ row?.maneuver_end }}
                            </td>
                        </ng-container>
                        <!-- Name Column -->
                        <ng-container matColumnDef="maneuver_duration">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                Durée
                            </th>
                            <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                                (click)="getItemDetails(row)">
                                {{ row?.maneuver_duration | formatTime }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="avg_speed">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                Vitesse moy
                            </th>
                            <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                                (click)="getItemDetails(row)">
                                <p *ngIf="row?.maneuver_type != 'Inactivité'">{{row?.avg_speed}}km/h </p>

                                <p *ngIf="row?.maneuver_type === 'Inactivité'">--</p>
                            </td>
                        </ng-container>
                        <!-- Progress Column -->
                        <ng-container matColumnDef="max_speed">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                Vitesse max
                            </th>
                            <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                                (click)="getItemDetails(row)">
                                <p *ngIf="row?.maneuver_type != 'Inactivité'">{{row?.max_speed}}km/h</p>
                                <p *ngIf="row?.maneuver_type === 'Inactivité'">--</p>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row (click)="goToBottom(820)" *matRowDef="let row; columns: displayedColumns"
                            (dblclick)="dbClickitem(row?.id , row?.unit_id , row?.trip_id , row?.maneuver_id ,row?.search, row)">
                        </tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="12">
                                Aucune donnée
                            </td>
                        </tr>
                    </table>
                    <mat-paginator #paginator
                      [pageSize]="15"
                      (page)="pageChanged($event)"
                      [pageSizeOptions]="[15, 30, 100]"
                      showFirstLastButtons
                      >
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>
    <ng-template #filtrage>
        <button class="close " matDialogClose>X</button>
        <form class="mt-4" [formGroup]="registerForm" style="margin-right: 3%;">
            <div class="row">
                <div class="col-md-8 w-100 mb-2">
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <mat-form-field class="mb-2 mat-form-field-wrapper">
                                <mat-label>ID. Dallas</mat-label>
                                <input #input formControlName="dallas" matInput>
                            </mat-form-field>
                            <mat-form-field class="mat-form-field-wrapper">
                                <mat-label>Prénom ou Nom du conducteur</mat-label>
                                <input #input formControlName="driver_name" matInput>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="mb-2 mat-form-field-wrapper">
                                <mat-label>Nom de véhicule</mat-label>
                                <input #input formControlName="unit_id" matInput>
                            </mat-form-field>
                            <!-- <mat-form-field class="mb-2 mat-form-field-wrapper">
                                <mat-label>Plaque Véhicule</mat-label>
                                <input matInput #input formControlName="plate">
                            </mat-form-field> -->
                            <mat-form-field appearance="fill" class="mat-form-field-wrapper">
                                <mat-label>Type de véhicule</mat-label>
                                <mat-select #input [formControl]="registerForm?.controls.unit_type2" multiple>
                                    <mat-select-trigger *ngFor="let item of registerForm?.controls?.unit_type2">
                                        {{registerForm.controls.unit_type2.value ?
                                        registerForm.controls.unit_type2.value[0] : ''}}
                                        <span *ngIf="registerForm.controls?.unit_type2.value?.length > 1"
                                            class="example-additional-selection">
                                            (+{{registerForm.controls.unit_type2.value.length - 1}}
                                            {{registerForm.controls.unit_type2.value?.length === 2
                                            ?'autre' :'autres'}})
                                        </span>
                                    </mat-select-trigger>
                                    <mat-option *ngFor="let topping of toppingList" [value]="topping">
                                        {{topping?.typeVehicule}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-12 mb-2">
                            <mat-form-field class="mb-2 mat-form-field-wrapper">
                                <mat-label>Min Score de sécurité</mat-label> <input #input
                                    formControlName="safety_score_min" type="number" matInput [(ngModel)]="minValue">
                                <span matSuffix>%&nbsp;</span>
                            </mat-form-field>
                            <mat-form-field class="mb-3 mat-form-field-wrapper">
                                <mat-label>Max Score de sécurité</mat-label> <input #input
                                    formControlName="safety_score_max" type="number" matInput [(ngModel)]="maxValue">
                                <span matSuffix>%&nbsp;</span>
                            </mat-form-field>
                            <ngx-slider [(value)]="minValue" [(highValue)]="maxValue" [options]="options">
                            </ngx-slider>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 mb-5">
                    <ngx-slider formControlName="maneuver_type2" [(value)]="value1" [options]="options1"></ngx-slider>
                </div>
                <div class="col-xl-12 col-lg-10 col-md-10  mt-3">
                </div>
                <div class="col-10"></div>
                <div class="col-2 d-flex">
                    <img placement="left" ngbTooltip="Réinitialiser" src="assets/icons/actualiser.svg"
                     (click)="withFiltre=false;resetValue()" style="    height: 80%;
                       " />
                    <img placement="left" ngbTooltip="Rechercher" src="assets/icons/cherche.svg"
                        (click)="withFiltre=true;submitForm()" style="    height: 80%;
                       " />
                </div>
            </div>
        </form>
    </ng-template>
